import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlanProvider } from "../../../../contexts/PlanOperationContext/Plan";
import { selectOneSetting, selectPermissions } from "../../../../util/store/selectors";
import { getStore } from "../../../../util/store/store";
import { getKeyWeek, getMondayByKey, getSundayByKey, jumpToTarget, SCROLL_TYPE } from "../../../../util/varibles/global";
import { ACTION } from "../../../../util/varibles/permission";
import { PlanSetting } from "../../../../util/varibles/userSetting";
import { calendarSizes } from "../../_components/CalendarViewSelect";
import { CALENDAR_ID, selectPlan } from "../../constants";
import { planOpActions } from "../../reducer";
import Vessels from "./_components/Vessels";
import styles from './style.module.scss';

export default function HorizontalCalendar() {
    const calendarRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch()
    const [canUseVesselMenu, canUseOperationMenu, canUpdateOperation] = useSelector(selectPermissions([
        ACTION.PLAN_OP.VESSEL_MENU,
        ACTION.PLAN_OP.OP_MENU,
        ACTION.PLAN_OP.UPDATE_OP,
    ]));
    const weeks = useSelector(selectPlan.weeks);
    const [startTime, finishTime] = useMemo(() => [getMondayByKey(weeks[0]).time, getSundayByKey(weeks[weeks.length - 1]).time], [weeks]);

    useEffect(() => {
        const state = getStore();
        const setting = selectOneSetting(PlanSetting.CALENDAR_VIEW_SIZE)(state);
        const { width = 70 } = calendarSizes[setting] || {};
        calendarRef.current?.style.setProperty('--date-per-screen', `${width}px`);
        setTimeout(() => {
            const week = getKeyWeek(Date.now());
            jumpToTarget(CALENDAR_ID, week, SCROLL_TYPE.HORIZONTAL);
        }, 100)
    }, []);

    return <div
        ref={calendarRef}
        id={CALENDAR_ID}
        className={styles.calendar}
        style={{ '--calendar-left': startTime, '--calendar-width': finishTime - startTime } as any}
    >
        <PlanProvider
            startCalendar={startTime}
            endCalendar={finishTime}
            calendarRef={() => calendarRef.current as HTMLDivElement}
            onDragOp={params => dispatch(planOpActions.dragOperation(params))}
            permission={{
                VESSEL_MENU: canUseVesselMenu,
                OP_MENU: canUseOperationMenu,
                UPDATE_OP: canUpdateOperation,
            }}
        >
            <Vessels />
        </PlanProvider>
    </div>
}
